var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container-fluid',[(_vm.tipoSoggetto === 2 || _vm.tipoSoggetto === 4)?_c('div',[_c('InstituteDetails',{attrs:{"instituteInfo":_vm.instituteData}})],1):_vm._e(),(_vm.tipoSoggetto === 3)?_c('div',[_c('EnterpriseDetails')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }